import VueTypes from 'vue-types'

export const InputMixin = {
  props: {
    inputKey: {
      type: String,
      required: true
    },
    parameters: {
      type: Object,
      required: true
    },
    isDisabled: VueTypes.bool.def(false)
  },

  data () {
    return {
      inputData: null
    }
  },

  computed: {
    /**
     * @returns {string}
     */
    name () {
      return this.parameters.name || 'input label'
    },

    /**
     * @returns {object}
     */
    rules () {
      const rules = []

      // dont need rules if field is disabled
      if (this.isDisabled) {
        return rules
      }

      if (this.parameters.required) {
        rules.push({
          required: true,
          message: `Please select ${this.name}`,
          trigger: 'change'
        })
      }

      if (this.parameters.minLength !== undefined) {
        rules.push({
          min: this.parameters.minLength,
          message: `${this.name} must be atleast be ${this.parameters.minLength} characters long`,
          trigger: 'change'
        })
      }

      if (this.parameters.maxLength !== undefined) {
        rules.push({
          max: this.parameters.maxLength,
          message: `${this.name} cannot be longer than ${this.parameters.maxLength} characters`,
          trigger: 'change'
        })
      }

      return rules
    },

    /**
     * @returns {Array}
     */
    notes () {
      return this.parameters.notes || []
    },

    /**
     * @returns {string}
     */
    disabledMessage () {
      return this.parameters.disabledMessage
    }
  },

  created () {
    this.initInput()
  },

  methods: {
    /**
     */
    setData () {
      this.$emit('set-data', {
        key: this.inputKey,
        value: this.inputData,
        relatedField: this.parameters.relatedField,
        trigger: this.parameters.trigger
      })
    }
  }
}
